import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { Menu, Image, Icon, Dropdown, Message } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { URL } from 'Constants'

class TopBar extends Component {
  gotoHelpHref() {
    let path = window.location.pathname.toLowerCase();
    let helpPath = "tenant_report-overview";
    if (path.startsWith("/calls/summary")) {
      helpPath = "calls_summary";
    } else if (path.startsWith("/calls/list")) {
      helpPath = "calls_list";
    } else if (path.startsWith("/calls/chloroplethmap")) {
      helpPath = "calls_map";
    }
   
    window.open(URL.HELP + helpPath, "_blank");
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        <Messenger {...this.props} />
        <Menu fixed="top" inverted >
          <Menu.Item onClick={this.props.menuToggle} as="div" className="nav control" id="HeaderHamburger">
            <Icon className="menu polycom" size="large"/>
          </Menu.Item>
          <Menu.Menu className="cloud services" id="HeaderPolyCloudServices">
            <Menu.Item href={URL.CONSOLE} className="logo">
              <Image alt="Poly Cloud Services" src="/img/lockup.svg" />
              <div>{t("Polycom.CloudServices")}</div>
            </Menu.Item>
            <div className="divider" />
            <div className="item">{t("Polycom.RCTenantReport")}</div>
          </Menu.Menu>
          <Menu.Menu position="right">
            <Menu.Item
              onClick={this.gotoHelpHref}
              id="HeaderInfo"
            >
              <Icon className="polycom help circle fill fitted" size="large" alt="Get Info" />
            </Menu.Item>
            <Dropdown item icon={null} id="HeaderLanguageDropdown"
              trigger={
                <span>
                  <Icon className="polycom language fitted" size="large" alt="Change Language" 
                  />English
                </span>
              }>
              <Dropdown.Menu>
                <Dropdown.Item
                  text="English"
                  href="#"
                  id="HeaderLanguageDropdownEnglish"
                />
              </Dropdown.Menu>
            </Dropdown>
            <UserButton userName={this.props.userName} isRejected={this.props.isRejected} t={t}/>
          </Menu.Menu>
        </Menu>
      </div>
    );
  }
};

class UserButton extends Component {
  render() {
    const { t } = this.props;
    if (this.props.isRejected) {
      return (
        <Menu.Item 
          href="/logout"
          id="HeaderUserButtonLogout"
        >
          <Icon className="polycom account circle fitted"  size="large" />Log Out
        </Menu.Item>
      );
    }
    if (this.props.userName === "") {
      return (
        <Menu.Item 
          href={URL.ORION_OAUTH + "&redirect_uri=" + encodeURIComponent(window.location.href)}
          id="HeaderUserButtonLogin"
        >
          <Icon className="polycom account circle fitted"  size="large" />Log In
        </Menu.Item>
      );
    }
    return (
      <Dropdown item icon={null} 
        trigger={
          <span id="HeaderUserButton">
            <Icon className="polycom account circle fitted" size="large"/>{this.props.userName}
          </span>
        }>
        <Dropdown.Menu>
          <Dropdown.Item
            text={t("User.Profile")}
            href={URL.PROFILE + window.location.href}
            id="HeaderUserButtonProfile"
          />
          <Dropdown.Item 
            text={t("User.Logout")}
            as={Link}
            to="/logout"
            id="HeaderUserButtonLogout"
          />
        </Dropdown.Menu>
      </Dropdown>
    )
  }
};

class Messenger extends Component {
  render() {
    if (!this.props.message.doDisplay) {
      return null;
    }
    return (
      <div className="topMessage">
        <Message floating color={this.props.message.color}>
          <Message.Header>{this.props.message.header}</Message.Header>
          <p>{this.props.message.text}</p>
        </Message>
      </div>
    )
  }
};

const mapToProps = state => {
  return {
    message: state.message.message,
    userName: state.userSession.userName,
    isRejected: state.userSession.rejected
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(TopBar)
);
